"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZoneVsColliderRule = void 0;
var core_1 = require("@inter-ikea-core/core");
var FunctionalZoneValidationBase_1 = require("./FunctionalZoneValidationBase");
var ZoneVsColliderValidationResult_1 = require("./ZoneVsColliderValidationResult");
/**
 * A validation that fails if a functional zone with a specified layer intersects with a collider of another entity.
 *
 * An example use case is a door. It could specify a functional zone that represents the area where the door can be opened.
 * Then you could use this rule to make sure that the door doesn't collide with anything when it is opened.
 */
var ZoneVsColliderRule = /** @class */ (function (_super) {
    __extends(ZoneVsColliderRule, _super);
    /**
     *  creates a new ZoneVsColliderRule. It will check for intersections between the functional zones that belong to the
     *  specified layer and colliders of other entities.
     *
     * @param restrictedLayer the layer of the functional zones that should be checked for intersections
     * @param severity the severity of the validation result, WARNING or ERROR
     * @param includeAncestors if false, the rule will ignore collisions with the colliders of the entity's ancestors.
     */
    function ZoneVsColliderRule(restrictedLayer, severity, includeAncestors) {
        var _this = _super.call(this) || this;
        _this.restrictedLayer = restrictedLayer;
        _this.severity = severity;
        _this.includeAncestors = includeAncestors;
        _this.id = "ZoneVsColliderRule layer:".concat(restrictedLayer, " vs colliders");
        return _this;
    }
    /**
     * Explicitly tests zones on two entities, and only on them, no hierarchies iterated
     */
    ZoneVsColliderRule.prototype.checkIntersectingZones = function (entity, other) {
        var _this = this;
        if (other.hasComponent(core_1.ComponentIds.FUNCTIONAL_ZONES_WORLD_COMPONENT_ID)
            && entity.hasComponent(core_1.ComponentIds.COLLIDER_COMPONENT_ID)) {
            var myColliderPolyhedron_1 = entity.getComponentUnsafe(core_1.ComponentIds.COLLIDER_COMPONENT_ID).worldPolyhedron;
            var otherZones = other.getComponentUnsafe(core_1.ComponentIds.FUNCTIONAL_ZONES_WORLD_COMPONENT_ID).zones;
            var intersectingZone = otherZones.find(function (zone) { return zone.layer === _this.restrictedLayer && zone.polyhedron.penetration(myColliderPolyhedron_1); });
            if (intersectingZone)
                return new ZoneVsColliderValidationResult_1.ZoneVsColliderValidationResult(this.severity, this, other, intersectingZone, entity, myColliderPolyhedron_1);
        }
        return null;
    };
    /**
     * Checks zone vs collider intersection of the hierarchy of the entity against another specified entity.
     * In case the other entity is part of the own hierarchy then it is excluded from testing.
     * In case the other entity is an ancestor then the property includeAncestors of the rule determines
     * if it should be included in testing or not.
     */
    ZoneVsColliderRule.prototype.checkZoneIntersectionOfOwnHierarchy = function (snapRootHierarchy, entity, other, parentOfEntityToValidate) {
        if (snapRootHierarchy.includes(other)) // Don't check against entities in our own hierarchy
            return null;
        // Either generate warnings even for ancestor or make sure it isn't an ancestor
        if (!this.includeAncestors && this.potentialParentIsAncestor(other, parentOfEntityToValidate))
            return null;
        // Check results both ways, zone vs collider and collider vs zone
        var result = this.checkIntersectingZones(entity, other);
        if (result)
            return result;
        var resultOtherWay = this.checkIntersectingZones(other, entity);
        if (resultOtherWay)
            return resultOtherWay;
        return null;
    };
    return ZoneVsColliderRule;
}(FunctionalZoneValidationBase_1.FunctionalZoneValidationBase));
exports.ZoneVsColliderRule = ZoneVsColliderRule;
//# sourceMappingURL=ZoneVsColliderRule.js.map